import { render, staticRenderFns } from "./NFseForm.vue?vue&type=template&id=455ab1ea"
import script from "./NFseForm.vue?vue&type=script&lang=js"
export * from "./NFseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports